import React from 'react';
import PropTypes from 'prop-types';

const AlertMessage = (props) => {
  if (!props.show) {
    return null;
  }

  return (
    <div className="alert-message">
      You are about to hide a unit that has resources shared with classes and
      assessments assigned to classes. If you proceed, the resources in the unit
      will no longer be visible to classes. Assessments will continue to show
      for classes until the assignments are marked completed or deleted. Do you
      want to proceed?
    </div>
  );
};

AlertMessage.displayName = 'AlertMessage';

AlertMessage.propTypes = {
  show: PropTypes.bool,
};

export default AlertMessage;
